<template>
    <input-field v-mask="'##'"  v-model="modelValue" :stretch="stretch" v-bind="$attrs" :readonly="readonly" :disabled="disabled" :id="id" :name="name" :placeholder="placeholder">
        <slot></slot> {{ periodo }}-{{ mes }}-
    </input-field>
</template>
<script>
export default {
    props : {
        id : {
            required : false,
            default : function () {
                return null;
            }
        },
        name : {
            type : String,
            default : ''
        },
        placeholder : {
            type : String,
            required : false,
            default : 'Escriba...'
        },
        readonly : {
            type : Boolean,
            required : false,
            default : false
        },
        disabled : {
            type : Boolean,
            required : false,
            default : false
        },
        stretch : {
            type : Boolean,
            required : false,
            default : false
        },
        value : {
            required : false,
            default : ''
        }
    },
    data : function () {
        return {
            periodo : periodo,
            mes : mes,
            modelValue : ''
        };
    },
    updated : function () {
        let that = this;
        let element = document.getElementById(this.id);
        if (element !== undefined && element !== null) {
            element.onblur = function () {
                if (that.modelValue != null)
                    that.modelValue = that.modelValue.padStart(2, '0');
                let newDate = new Date(moment(new Date(that.periodo + '-' + that.mes + '-01 00:00:00')).format('YYYY-MM-') + that.modelValue + ' 00:00:00');
                if(newDate == 'Invalid Date') {
                    let dia = '';
                    that.modelValue = dia;
                    that.input();
                }
                else 
                    that.input();
            };
        }
    },
    methods :  {
        input : function () {
            if (this.modelValue.length > 0) {
                let date = new Date(this.periodo + '-' + this.mes + '-01 00:00:00');
                let dia = this.modelValue.padStart(2, '0');
                let newDate = new Date(moment(date).format('YYYY-MM-') + dia + ' 00:00:00');
                if (newDate != 'Invalid Date')
                    this.$emit('input', moment(newDate).format('YYYY-MM-DD'));
            }
            else 
                this.$emit('input', '');
        }
    },
    mounted : function () {
        if (this.value !== null && this.value !== undefined && this.value !== '') {
            let date = new Date(this.value + ' 00:00:00');
            this.modelValue = moment(date).format('DD');
        }
    },
    watch :  {
        value : function (value) {
            if (value !== null && value !== undefined && value !== '') {
                let date = new Date(value + ' 00:00:00');
                this.modelValue = moment(date).format('DD');
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/DatePicker2.vue